<div class="no-print go-back-link" fxLayout="row" [fxLayoutAlign]="'start center'">
  <i class="go-back-link-arrow zmdi zmdi-long-arrow-left"></i>
  <span *ngIf="label; else backCommonLabel">{{ label }}</span>
  <ng-template #backCommonLabel>{{ backText | translate }}</ng-template>
</div>
